import React from "react";

/**
 * Hygiene Kitchens brand logo.
 * Two variants: "mark" (just the bracket-H smile glyph) and "full" (mark + wordmark).
 */
export function Logo({ variant = "mark", className = "", invert = false, "data-testid": testId, ...rest }) {
  const src = "/brand/hygiene-logo.png";
  // On a white sidebar/header we deliberately ignore `invert` so the logo's red+black stays vivid.
  const style = invert ? { objectFit: "contain" } : { objectFit: "contain" };
  return (
    <img
      src={src}
      alt="Hygiene Kitchens"
      className={className}
      style={style}
      data-testid={testId || `logo-${variant}`}
      {...rest}
    />
  );
}

export default Logo;
